import { WIDGET_CATALOG } from "@/lib/widgetCatalog";
import { newWid } from "@/lib/builderOps";

const KNOWN_TYPES = new Set(WIDGET_CATALOG.map((w) => w.type));

const num = (v, d) => (Number.isFinite(Number(v)) ? Number(v) : d);

// Coerce one widget into a render-safe shape; returns null when unusable.
export function sanitizeWidget(w) {
  if (!w || typeof w !== "object") return null;
  const type = KNOWN_TYPES.has(w.type) ? w.type : null;
  if (!type) return null;
  const cfg = (w.config && typeof w.config === "object") ? w.config : {};
  const config = {
    ...cfg,
    dimensions: Array.isArray(cfg.dimensions) ? cfg.dimensions.filter((d) => d && typeof d === "object") : [],
    measures: Array.isArray(cfg.measures) ? cfg.measures.filter((m) => m && typeof m === "object") : [],
    filters: Array.isArray(cfg.filters) ? cfg.filters : [],
  };
  const lay = (w.layout && typeof w.layout === "object") ? w.layout : {};
  return {
    ...w,
    id: typeof w.id === "string" && w.id ? w.id : newWid(),
    type,
    title: typeof w.title === "string" ? w.title : "",
    dataset_id: w.dataset_id || null,
    config,
    layout: { x: num(lay.x, 0), y: num(lay.y, 0), w: Math.max(1, num(lay.w, 6)), h: Math.max(2, num(lay.h, 5)) },
  };
}

export function sanitizeWidgets(list) {
  const widgets = [];
  let dropped = 0;
  (Array.isArray(list) ? list : []).forEach((w) => {
    const s = sanitizeWidget(w);
    if (s) widgets.push(s); else dropped += 1;
  });
  return { widgets, dropped };
}

// Merge AI-returned widgets with the current canvas: existing widgets always keep
// their layout/group/lock state; new widgets are appended below existing content.
export function mergeAiWidgets(current, incoming, cols = 12) {
  const curById = {};
  (current || []).forEach((w) => { curById[w.id] = w; });
  let maxY = (current || []).reduce((m, w) => Math.max(m, (w.layout?.y || 0) + (w.layout?.h || 4)), 0);
  const { widgets: safe, dropped } = sanitizeWidgets(incoming);
  const merged = safe.map((w) => {
    const cur = curById[w.id];
    if (cur) {
      return {
        ...w,
        layout: cur.layout || w.layout,
        layout_mobile: cur.layout_mobile,
        hidden_mobile: cur.hidden_mobile,
        group_id: cur.group_id,
        locked: cur.locked,
        hidden: cur.hidden,
      };
    }
    const h = Math.max(2, w.layout?.h || 5);
    const placed = { ...w, layout: { x: 0, y: maxY, w: Math.min(cols, Math.max(1, w.layout?.w || 6)), h } };
    maxY += h;
    return placed;
  });
  return { widgets: merged, dropped };
}
